import { type OnChangeFn, type SortingState, getCoreRowModel } from "@tanstack/react-table"
import type { FC, RefObject } from "react"
import type { CombinedError } from "urql"

import { useProductInventoryPalletColumns } from "../../hooks"

import { AerosBaseTable } from "@/components/Tables/Aeros/components/AerosBaseTable"
import type { InventoryByPalletItem, Product } from "@/graphql/codegen/graphql"

interface ProductInventoryPalletsTableProps {
  product: Product
  data: InventoryByPalletItem[]
  loading?: boolean
  error?: CombinedError | Error
  sorting: SortingState
  containerRef?: RefObject<HTMLDivElement>
  canMaintain: boolean
  onSortingChange: OnChangeFn<SortingState>
  onScroll?: () => void
  onHoldPut?: (item: InventoryByPalletItem) => void
  onHoldRelease?: (item: InventoryByPalletItem) => void
  onTransfer?: (item: InventoryByPalletItem) => void
  onCombinePallets?: (item: InventoryByPalletItem) => void
  onCoaView?: (item: InventoryByPalletItem) => void
}

export const ProductInventoryPalletsTable: FC<ProductInventoryPalletsTableProps> = ({
  product,
  data,
  error,
  loading = false,
  sorting,
  containerRef,
  canMaintain,
  onSortingChange,
  onScroll,
  onHoldPut,
  onHoldRelease,
  onTransfer,
  onCombinePallets,
  onCoaView,
}) => {
  const columns = useProductInventoryPalletColumns({
    product,
    canMaintain,
    onHoldPut,
    onHoldRelease,
    onTransfer,
    onCombinePallets,
    onCoaView,
  })

  return (
    <AerosBaseTable
      error={error}
      features={{
        table: {
          stickyHeader: true,
        },
        tanstackOptions: {
          data,
          columns,
          state: {
            sorting,
            isLoading: loading,
          },
          manualSorting: true,
          enableSorting: true,
          enableMultiSort: false,
          enableSortingRemoval: false,
          getCoreRowModel: getCoreRowModel(),
          onSortingChange,
        },
      }}
      slotProps={{
        container: { ref: containerRef, onScroll },
      }}
      noDataMessage='No pallet inventory records found'
    />
  )
}
